import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { PlayerPoints } from '../../../database.schema';
import { CentreHeading, SectionWrapper } from '../common-styles/common-styles';

const IndividualWrapper = styled.div`
  margin: 0.5rem 0 0;
  display: flex;
  justify-content: center;
  table,
  th,
  td {
    border-collapse: collapse;
  }
`;

const CaptainsPointsHeader = styled.th`
  width: 5rem;
  font-weight: bold;
  padding: 0 0 0.25rem;
  font-size: 18px;
`;

const IndividualPointsHeader = styled.th`
  width: 9rem;
  font-weight: bold;
  padding: 0 0 0.25rem;
  font-size: 18px;
`;

const Points = styled.td`
  text-align: right;
  padding-right: 1.5rem;
`;
const Position = styled.th`
  min-width: 1rem;
`;

type Props = {
  individualPoints?: Array<PlayerPoints>;
  captainsPoints?: Array<PlayerPoints>;
};
export const IndividualStandings: FC<Props> = ({ individualPoints, captainsPoints }): JSX.Element => {
  const [showIndividualPoints, setShowIndividualPoints] = useState<boolean>(true);
  const [showCaptainsPoints, setShowCaptainsPoints] = useState<boolean>(false);
  return (
    <SectionWrapper>
      <CentreHeading>
        <h2>Individual Standings</h2>
      </CentreHeading>
      <IndividualWrapper>
        <table>
          <thead>
            <tr
              data-testid="individual-tabel-headings"
              onClick={() => {
                setShowCaptainsPoints(!showCaptainsPoints);
                setShowIndividualPoints(!showIndividualPoints);
              }}
            >
              <Position></Position>
              <th></th>
              {showIndividualPoints ? <IndividualPointsHeader>Stableford(Avg)</IndividualPointsHeader> : <CaptainsPointsHeader>Captains</CaptainsPointsHeader>}
              {showCaptainsPoints ? <IndividualPointsHeader>Stableford(Avg)</IndividualPointsHeader> : <CaptainsPointsHeader>Captains</CaptainsPointsHeader>}
              <th>
                <img src="/sort-arrow-in-circle.png" loading="lazy" alt="Sort " title="Sort " width="27" height="27" />
              </th>
            </tr>
          </thead>
          <tbody>
            {showIndividualPoints &&
              individualPoints?.map((player: PlayerPoints, index: number) => (
                <tr key={`individual-${player.player.id}-${index}`}>
                  <td data-testid={`ind-position-${index}`}>{player.position}</td>
                  <td data-testid={`ind-player-${index}`}>{player.player.nickName}</td>
                  <Points data-testid={`ind-points-${index}`}>{`${player.points} (${player.average})`}</Points>
                  <Points data-testid={`cpt-points-${index}`}>{player.captainPoints}</Points>
                  <td></td>
                </tr>
              ))}
            {showCaptainsPoints &&
              captainsPoints?.map((player: PlayerPoints, index: number) => (
                <tr key={`captains-${player.player.id}-${index}`}>
                  <td data-testid={`ind-position-${index}`}>{player.position}</td>
                  <td data-testid={`ind-player-${index}`}>{player.player.nickName}</td>
                  <Points data-testid={`cpt-points-${index}`}>{player.captainPoints}</Points>
                  <Points data-testid={`ind-points-${index}`}>{`${player.points} (${player.average})`}</Points>
                  <td></td>
                </tr>
              ))}
          </tbody>
        </table>
      </IndividualWrapper>
    </SectionWrapper>
  );
};
